import React, { useState } from "react";
import { Upload, Message, Progress, Modal } from "@arco-design/web-react";
import { IconPlus, IconEdit } from "@arco-design/web-react/icon";
import Cropper from "./Cropper";

export default function (props) {
  const [file, setFile] = useState({ url: props.value });
  const cs = `arco-upload-list-item${file && file.status === "error" ? " is-error" : ""}`;
  const beforeUpload = file => {
    console.log(file,999);
    return new Promise(resolve => {
      const modal = Modal.confirm({
        title: "裁剪图片",
        icon: null,
        onCancel: () => {
          Message.info("取消上传");
          resolve(false);
          modal.close();
        },
        simple: false,
        style: { width: 800 },
        content: (
          <Cropper
            file={file}
            onOk={file => {
              resolve(file);
              modal.close();
            }}
            onCancel={() => {
              resolve(false);
              Message.info("取消上传");
              modal.close();
            }}
          />
        ),
        footer: null
      });
    });
  };
  return (
    <Upload
      style={{ width: 224, height: 120 }}
      action={`/api/file/upload?process=${props.process}`}
      fileList={file ? [file] : []}
      tip={file?.status === "error" ? "上传失败" : "支持png、jpg图片"}
      accept={".png,.jpeg,.jpg"}
      showUploadList={false}
      beforeUpload={beforeUpload}
      onChange={(_, currentFile) => {
        const { status } = currentFile;
        switch (status) {
          case "init":
          case "uploading":
            setFile({
              ...currentFile,
              url: URL.createObjectURL(currentFile.originFile)
            });
            break;
          case "error":
            Message.error("上传失败，请重试!");
            setFile({
              ...currentFile,
              url: ""
            });
            break;
          case "done":
            setFile({
              ...currentFile,
              url: currentFile.response.data
            });
            Message.success("上传成功!");
            props.onChange?.(currentFile.response.data);
            break;
        }
      }}
      onProgress={currentFile => {
        setFile(currentFile);
        if (currentFile.percent === 100) {
          setFile({
            ...currentFile,
            percent: 90
          });
        }
      }}
    >
      <div className={cs}>
        {file && file.url ? (
          <div className="arco-upload-list-item-picture custom-upload-avatar">
            <img src={file.url} />
            <div className="arco-upload-list-item-picture-mask">
              <IconEdit />
            </div>
            {file.status === "uploading" && file.percent < 100 && (
              <Progress
                percent={file.percent}
                type="circle"
                size="mini"
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translateX(-50%) translateY(-50%)"
                }}
              />
            )}
          </div>
        ) : (
          <div className="arco-upload-trigger-picture">
            <div className="arco-upload-trigger-picture-text">
              <IconPlus />
            </div>
          </div>
        )}
      </div>
    </Upload>
  );
}
